/**
 * Salibay Global Commerce - Theme JavaScript
 * Mobile-First, Blazing Fast Vanilla JS Engine
 */

(function () {
  'use strict';

  // State
  window.Salibay = window.Salibay || {};
  const FREE_DELIVERY_THRESHOLD_KES = 15000;

  // 1. Toast Notification Utility
  window.Salibay.showToast = function (message, icon = 'check_circle') {
    let toast = document.getElementById('salibay-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'salibay-toast';
      toast.className = 'salibay-toast';
      document.body.appendChild(toast);
    }
    toast.replaceChildren();
    const toastIcon = document.createElement('span');
    toastIcon.className = 'material-symbols-outlined';
    toastIcon.dataset.icon = icon;
    toastIcon.setAttribute('aria-hidden', 'true');
    const toastMessage = document.createElement('span');
    toastMessage.textContent = message;
    toast.setAttribute('role', 'status');
    toast.append(toastIcon, toastMessage);
    toast.classList.add('show');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => {
      toast.classList.remove('show');
    }, 2800);
  };

  // 2. Countdown Timer Logic
  function initCountdowns() {
    // Flash Deals Timer
    const hoursEl = document.getElementById('flash-hours');
    const minsEl = document.getElementById('flash-mins');
    const secsEl = document.getElementById('flash-secs');

    if (hoursEl && minsEl && secsEl) {
      let secondsRemaining = 4 * 3600 + 42 * 60 + 19;
      setInterval(() => {
        if (secondsRemaining > 0) {
          secondsRemaining--;
          const h = Math.floor(secondsRemaining / 3600);
          const m = Math.floor((secondsRemaining % 3600) / 60);
          const s = secondsRemaining % 60;
          hoursEl.textContent = String(h).padStart(2, '0');
          minsEl.textContent = String(m).padStart(2, '0');
          secsEl.textContent = String(s).padStart(2, '0');
        }
      }, 1000);
    }

    // Next Flight Departure Timer
    const flightTimerEl = document.getElementById('flight-departure-timer');
    if (flightTimerEl) {
      let flightSeconds = 14 * 3600 + 18 * 60 + 45;
      setInterval(() => {
        if (flightSeconds > 0) {
          flightSeconds--;
          const fh = Math.floor(flightSeconds / 3600);
          const fm = Math.floor((flightSeconds % 3600) / 60);
          flightTimerEl.textContent = `${fh}h ${fm}m`;
        }
      }, 60000);
    }
  }

  // 3. Cart Drawer & AJAX Cart Engine
  window.Salibay.openCartDrawer = function () {
    const drawer = document.getElementById('salibay-cart-drawer');
    const overlay = document.getElementById('salibay-cart-overlay');
    if (drawer && overlay) {
      drawer.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      window.Salibay.refreshCartDrawer();
    }
  };

  window.Salibay.closeCartDrawer = function () {
    const drawer = document.getElementById('salibay-cart-drawer');
    const overlay = document.getElementById('salibay-cart-overlay');
    if (drawer && overlay) {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  window.Salibay.refreshCartDrawer = async function () {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      window.Salibay.renderCart(cart);
      const response = await fetch('/?section_id=cart-drawer-render', { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      // Refresh server-rendered line items and checkout state without reloading the page.
      const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = markup.getElementById('salibay-cart-drawer');
      const drawer = document.getElementById('salibay-cart-drawer');
      if (updated && drawer) drawer.innerHTML = updated.innerHTML;
    } catch (err) {
      console.warn('Shopify cart.js fetch error (preview mode fallback)', err);
    }
  };

  window.Salibay.renderCart = function (cart) {
    // Update badge counts
    const countPills = document.querySelectorAll('.cart-count-badge');
    countPills.forEach(pill => {
      pill.textContent = cart.item_count || 0;
      pill.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    // Update total price display
    const totalKES = (cart.total_price / 100).toLocaleString('en-KE');
    const totalPills = document.querySelectorAll('.cart-total-display');
    totalPills.forEach(pill => {
      pill.textContent = `KES ${totalKES}`;
    });

    // Free delivery progress bar
    const totalAmount = cart.total_price / 100;
    const progressFill = document.getElementById('cart-delivery-progress-fill');
    const progressText = document.getElementById('cart-delivery-progress-text');
    if (progressFill && progressText) {
      const pct = Math.min(100, Math.round((totalAmount / FREE_DELIVERY_THRESHOLD_KES) * 100));
      progressFill.style.width = `${pct}%`;
      if (totalAmount >= FREE_DELIVERY_THRESHOLD_KES) {
        progressText.innerHTML = '<span class="text-[#006d3f] font-bold">🎉 Free Doorstep Nairobi Delivery Unlocked!</span>';
      } else {
        const remaining = (FREE_DELIVERY_THRESHOLD_KES - totalAmount).toLocaleString('en-KE');
        progressText.textContent = `Add KES ${remaining} more for Free Doorstep Delivery!`;
      }
    }
  };

  window.Salibay.addToCart = async function (variantId, quantity = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
      });
      if (res.ok) {
        const item = await res.json();
        window.Salibay.showToast(`Added ${item.title || 'item'} to your Salibay bag!`, 'shopping_bag');
        window.Salibay.openCartDrawer();
        return item;
      } else {
        const error = await res.json().catch(() => ({}));
        throw new Error(error.description || 'We could not add this item. Please try again.');
      }
    } catch (e) {
      window.Salibay.showToast(e.message || 'We could not add this item. Please try again.', 'error');
      return null;
    }
  };

  // 4. Landed Cost Calculator Modal
  window.Salibay.openCalculator = function () {
    window.location.assign('https://goshippingtracking.com/courier_goshipping/get-a-quote');
  };

  window.Salibay.closeCalculator = function () {
    const modal = document.getElementById('salibay-calc-modal');
    if (modal) modal.classList.remove('open');
  };

  window.Salibay.calculateLandedCost = function () {
    const originEl = document.getElementById('calc-origin');
    const priceEl = document.getElementById('calc-price');
    const weightEl = document.getElementById('calc-weight');
    const catEl = document.getElementById('calc-category');

    if (!priceEl || !weightEl) return;

    const basePrice = parseFloat(priceEl.value) || 0;
    const weightKg = parseFloat(weightEl.value) || 0.5;
    const origin = originEl ? originEl.value : 'USA';

    // Approximate USD/GBP/AED to KES rates
    let fxRate = 130; // USD to KES
    let airFreightPerKgKES = 1950; // GoShipping Air Cargo rate

    if (origin === 'UK') {
      fxRate = 170;
      airFreightPerKgKES = 2200;
    } else if (origin === 'UAE') {
      fxRate = 35.4;
      airFreightPerKgKES = 1500;
    } else if (origin === 'KENYA') {
      fxRate = 1;
      airFreightPerKgKES = 0;
    }

    const itemPriceKES = Math.round(basePrice * fxRate);
    const freightKES = Math.round(Math.max(1, weightKg) * airFreightPerKgKES);
    
    // Customs Duty: Kenya KRA standard tariffs
    let dutyRate = 0.25; // 25% import duty
    let vatRate = 0.16;  // 16% VAT
    let idfRdlRate = 0.055; // IDF 3.5% + RDL 2%

    if (origin === 'KENYA') {
      dutyRate = 0;
      vatRate = 0.16;
      idfRdlRate = 0;
    }

    const cif = itemPriceKES + freightKES;
    const importDuty = Math.round(cif * dutyRate);
    const idfRdl = Math.round(cif * idfRdlRate);
    const vat = Math.round((cif + importDuty) * vatRate);
    const customsTotal = importDuty + idfRdl + vat;

    const doorstepFee = cif > FREE_DELIVERY_THRESHOLD_KES ? 0 : 350;
    const totalLandedKES = itemPriceKES + freightKES + customsTotal + doorstepFee;

    // Output to UI
    const outSubtotal = document.getElementById('calc-out-subtotal');
    const outFreight = document.getElementById('calc-out-freight');
    const outCustoms = document.getElementById('calc-out-customs');
    const outDelivery = document.getElementById('calc-out-delivery');
    const outTotal = document.getElementById('calc-out-total');

    if (outSubtotal) outSubtotal.textContent = `KES ${itemPriceKES.toLocaleString('en-KE')}`;
    if (outFreight) outFreight.textContent = freightKES === 0 ? 'FREE' : `KES ${freightKES.toLocaleString('en-KE')}`;
    if (outCustoms) outCustoms.textContent = customsTotal === 0 ? 'KES 0 (Local)' : `KES ${customsTotal.toLocaleString('en-KE')}`;
    if (outDelivery) outDelivery.textContent = doorstepFee === 0 ? 'FREE' : `KES ${doorstepFee}`;
    if (outTotal) outTotal.textContent = `KES ${totalLandedKES.toLocaleString('en-KE')}`;
  };

  // Existing cart checkout callers use the store's configured payment providers.
  window.Salibay.openMpesaModal = function () {
    window.location.assign('/checkout');
  };

  window.Salibay.closeMpesaModal = function () {
    const modal = document.getElementById('salibay-mpesa-modal');
    if (modal) modal.classList.remove('open');
  };

  window.Salibay.triggerMpesaSTK = function () {
    window.location.assign('/checkout');
  };

  // 6. PDP Accordion Toggle
  window.Salibay.toggleAccordion = function (id) {
    const content = document.getElementById(id);
    const icon = document.getElementById(`${id}-icon`);
    if (!content) return;
    const isHidden = content.classList.contains('hidden');
    if (isHidden) {
      content.classList.remove('hidden');
      if (icon) icon.style.transform = 'rotate(180deg)';
    } else {
      content.classList.add('hidden');
      if (icon) icon.style.transform = 'rotate(0deg)';
    }
  };

  // 7. PDP Gallery Slider
  window.Salibay.setProductImage = function (src, index = 0) {
    const mainImg = document.getElementById('pdp-main-image');
    if (mainImg) mainImg.src = src;

    const dots = document.querySelectorAll('.pdp-gallery-dot');
    dots.forEach((d, i) => {
      if (i === index) {
        d.classList.add('bg-primary', 'w-6');
        d.classList.remove('bg-gray-300', 'w-2');
      } else {
        d.classList.remove('bg-primary', 'w-6');
        d.classList.add('bg-gray-300', 'w-2');
      }
    });
  };

  // 8. GoShipping Tracking Quick Search
  window.Salibay.trackShipment = function (waybillInputId = 'tracking-search-input') {
    const input = document.getElementById(waybillInputId);
    const waybill = input ? input.value.trim().toUpperCase() : '';
    if (!waybill) {
      window.Salibay.showToast('Please enter a waybill or order number', 'error');
      return;
    }
    window.Salibay.showToast(`Tracking waybill ${waybill}...`, 'radar');

    const resultBox = document.getElementById('tracking-result-box');
    if (resultBox) {
      resultBox.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // 9. Document Ready Initialization
  document.addEventListener('DOMContentLoaded', () => {
    initCountdowns();

    // Close overlays with Esc
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        window.Salibay.closeCartDrawer();
        window.Salibay.closeCalculator();
        window.Salibay.closeMpesaModal();
      }
    });

    // Listen for sample tracking chips
    document.querySelectorAll('.sample-chip').forEach(chip => {
      chip.addEventListener('click', function () {
        const waybill = this.dataset.waybill;
        const input = document.getElementById('tracking-search-input');
        if (input && waybill) {
          input.value = waybill;
          window.Salibay.trackShipment('tracking-search-input');
        }
      });
    });

    // Mobile nav active class sync
    const currentPath = window.location.pathname;
    document.querySelectorAll('.mobile-nav-item').forEach(item => {
      if (item.getAttribute('href') === currentPath) {
        item.classList.add('active');
      }
    });
  });

})();
